import { render, staticRenderFns } from "./VideoAnalysis.vue?vue&type=template&id=31f0570e&scoped=true&"
import script from "./VideoAnalysis.vue?vue&type=script&lang=js&"
export * from "./VideoAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./VideoAnalysis.vue?vue&type=style&index=0&id=31f0570e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../code/tibava/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f0570e",
  null
  
)

export default component.exports